export interface ISelectorListItem {
    id?: number;
    text: string;
}